const SEO_URL_QUERY_KEYS =
    Object.freeze(
        {
            GALLERY: 'gallerie',
            SERVICES: 'services',
            SEARCH_RADIUS: 'search_radius',
        }
    );

export default SEO_URL_QUERY_KEYS;
